<template>
	<div class="itempage" style="background: #fff;">
		<el-card style="position: relative;padding-bottom: 10px;">
			<div style="font-size: 20px;font-weight: bold;color: #4b92ff;">{{ title_1 }}</div>
			<div style="font-size: 16px;"><b>{{ title_2 }} • </b>{{ title_3 }}</div>
			<span style="font-size: 28px;position: absolute;right: 50px;top: 38%;">{{ title_4 }}</span>
			<div style="margin-left: 20px;position: absolute;right: 22%;top: 38%;">

				<el-dropdown placement="bottom" style="margin-left: 10px;">
					<el-button size="mini">
						{{ $t('message.button.actions') }}<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">

						<!-- <el-dropdown-item @click.native = "cc">创建变更</el-dropdown-item> -->
						<el-dropdown-item @click.native="addFavorite">{{ $t('message.button.bookmark') }}</el-dropdown-item>
						<el-dropdown-item @click.native="removeFavorite">{{ $t('message.button.cancelBookmark')
							}}</el-dropdown-item>

					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</el-card>



		<!-- tab切换 -->
		<div class="content">
			<ul class="content-title">
				<li @click="tabClick(item, index)" :class="{ active: index == num }" v-for="(item, index) in tabList"
					:key="index">
					{{ item.name }}</li>
			</ul>
			<div style="height: 6px;background: #ebebeb;"></div>

			<!-- <el-tabs style="margin-top: 10px;"  @tab-click="tabClick">
				<el-tab-pane :label="item.name" v-for="item in tabList">
				</el-tab-pane>
				<router-view :changeValue='change_to_child'></router-view>
			</el-tabs> -->
			<router-view :changeValue='change_to_child' @routeClick='reload' :type='user'></router-view>
		</div>
	</div>

</template>


<script>
import { userTabList } from "@/utils/publicstate";
import { getTabIndex } from "@/utils/index.js"

export default {
	name: 'UserItem',
	data() {
		return {

			changeInfo: [],//版本信息
			changeInfo_All: [],//change的所有信息
			change_value: "0",//change选中的信息
			change_to_child: "",//向子组件传送change信息
			user: 'user',
			base: '',
			title_number: "",
			title_1: "",
			title_2: "",
			title_3: "",
			title_4: "",
			page_one: [],
			tabList: [],
			loading: true,

		}
	},
	mounted() {
	},
	computed: {
		num() {
			return this.tabList.findIndex(i => i.path == this.$route.path)
		}
	},
	methods: {

		reload(e) {
			if (e == undefined) {
				this.logoInfo();
				return
			}
			const obj = {
				id: e.itemId,
				classId: e.itemClassId,
				subClassId: e.itemSubClassId,
				title: e[0]
			};
			this.getLink(obj);
		},
		addFavorite() {
			// console.log("addFavorite");
			this.addFavoriteInCommon(
				{
					baseClassId: this.Constants.userBaseClassId,
					number: this.title_number,
					id: this.$store.state.objectId.id
				}
			);
		},
		removeFavorite() {
			// console.log("removeFavorite");
			this.removeFavoriteInCommon(
				{
					baseClassId: this.Constants.userBaseClassId,
					number: this.title_number,
					id: this.$store.state.objectId.id
				}
			);
		},
		tabClick(res, index) {
			this.$router.push({
				path: res.path,
				query: { ...this.$store.state.objectId },
			});
			this.$store.commit('setTabIndex', { ...this.$store.state.objectId, index })
			// this.$store.commit('setTabID',index);
			// let obj = userTabList.filter( i => {return i.id == res.id })[0];
			// console.log(obj);
			// if(obj.id == "1090108") {
			// 	this.$router.push({
			// 		path:obj.path,
			// 	})
			// } else {
			// 	this.$router.push({
			// 		path:obj.path,
			// 	})
			// };

		},
		async logoInfo() {
			this.$http.get("/pmdm/admin/getTab/" + this.$store.state.objectId.subClassId).then(res => {
				this.tabList = res.data.object.tabs.map(i => {
					i.path = userTabList.find(j => j.id == i.id)?.path || ''
					return i;
				})
				const tabIndex = getTabIndex({ ...this.$store.state.objectId })?.index || 0
				this.tabClick(userTabList.find(j => j.id == this.tabList[tabIndex].id), tabIndex)
			})

			var obj_get = { //获取标题
				... this.$store.state.objectId,
				tableId: this.$store.state.tableId_1
			};
			var loadTableUrl = `/pmdm/admin/user/loadTable${this.params(obj_get)}`;
			const { //获取标题
				data: res2
			} = await this.$http.get(loadTableUrl);
			// const {//获取标题测试
			// 	data: res2
			// } = await this.$http.get("/pmdm/items/findItem/20049/1010101/1");
			//console.log(res2);
			if (res2.code !== 200)
				return this.$message.error(res.message);
			//console.log(Name);
			this.page_one = this.getNewData(res2.object.table.columnInfo);
			//console.log(this.page_one);
			var val_ = res2.object.table.rows[0].cells;

			//console.log(this.page_one);
			for (var i = 0; i < this.page_one.length; i++) {
				this.page_one[i].val = val_[i];
				if (this.page_one[i].id == 1090004) {
					this.title_1 = this.page_one[i].val.val;
					// this.tabClick(this.tabList[0]);

				};
				if (this.page_one[i].id == 1090003) {
					this.title_2 = this.page_one[i].val.val;
				};
				if (this.page_one[i].id == 1090001) {
					this.title_3 = this.page_one[i].val.val;
					this.title_number = this.page_one[i].val.val
					// this.updateTabName(this.title_number);
				};
				if (this.page_one[i].id == 1090002) {
					this.title_4 = this.page_one[i].val.val;
				};
			};

			this.addRecentVistInCommon(
				{
					baseClassId: this.Constants.userBaseClassId,
					number: this.title_number,
					id: this.$store.state.objectId.id
				}
			);

			this.updateFavoriteInCommon(
				{
					baseClassId: this.Constants.userBaseClassId,
					number: this.title_number,
					id: this.$store.state.objectId.id
				}
			);
		},



	},
	created() {
		this.$store.commit('setTabID', 0);
		const { id, classId, subClassId } = this.$route.query;
		const obj = { id, classId, subClassId };
		this.$store.commit('setObjectId', obj);
		this.logoInfo();

	}
}
</script>


<style scoped>
.content-title {
	padding: 0;
	margin: 0;
	overflow: hidden;
	background-size: 100% 100%;
	margin-left: 20px;
	height: 57px;
}

.content-title li {
	float: left;
	padding: 18px 12px 12px 12px;
	font-size: 16px;
	cursor: pointer;
	margin-right: 18px;
}

.content-title li:hover {
	border-bottom: 3px solid #4b92ff;
	color: #4b92ff;
}

.content-title .active {
	border-bottom: 3px solid #4b92ff;
	color: #4b92ff;
}
</style>